import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';                                                                                       
@Component({
  selector: 'app-viewfarmsmanagement',
  templateUrl: './viewfarmsmanagement.component.html',
  styleUrls: ['./viewfarmsmanagement.component.css']
})
export class ViewfarmsmanagementComponent implements OnInit {

  returnUrl= "/dashboard/farmsmanagement";
  getfarmsviewApi: string;
  getval:any;
  constructor(private router: Router,private commonService: CommonService) { }

 async ngOnInit() {
    let farmsId = sessionStorage.getItem('farmsId');
    this.getfarmsviewApi= "/farms/"+farmsId;
    (await this.commonService.getApi(this.getfarmsviewApi)).subscribe(
      res => {
        console.log(res.data);
        $("#FarmName").text(res.data.tnfr_name)
        $("#FarmID").text(res.data.tnfr_code)
        $("#ContactPerson").text(res.data.tnfr_farm_contact_name)
        $("#ContactEmail").text(res.data.tnfr_farm_contact_email)
        $("#ContactNumber").text(res.data.tnfr_farm_contact_number)
        $("#Address").text(res.data.tnfr_farm_address)
             })
  }
  farmsmanagement(){
    this.router.navigate([this.returnUrl]);
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
